export default function TradingPlatformBadge({platform}:{platform?:string|null}) {
  const label=platform==='mt4'?'MT4':platform==='mt5'?'MT5':'平台待确认';
  return <span className="inline-block rounded bg-surface px-1.5 py-0.5 text-[10px] text-text-secondary">{label}</span>;
}
